<template>
    <div class="admin-index-container">
        <div class="box-card">
            <div class="vc-index-nav text-left">
                <span><i class="el-icon-house margin-right-sm"></i>{{ $t('index.admin.home') }}</span>
                <span class="margin-left-sm margin-right-sm">/</span>
                <span>{{ $t('index.admin.platformData') }}</span>
            </div>
            <el-row :gutter="20" class="margin-top">
                <el-col v-for="(item, index) in adminIndexInfo.datas" :key="index" :xs="12" :sm="8" :md="6" :lg="4"
                    class="margin-bottom">
                    <el-card class="text-center" style="height:140px;">
                        <div style="font-size: 38px;font-weight: 600;" :style="{ 'color': item.color }">
                            {{ item.value }}
                        </div>
                        <div class="margin-top-lg" style="font-size: 20px;font-weight: 100;">
                            {{ item.name }}
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="">
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-card>
                        <div id="shopStoreOrderEchat" style="height:400px;width: 100%;"></div>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-card>
                        <div id="housekeepingStoreOrderEchat" style="height:400px;width: 100%;"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { queryAdminCount, queryStoreOrderDayCount } from '@/api/user/indexApi'
import * as echarts from 'echarts'

export default {
    name: 'AdminIndexList',
    data() {
        return {
            adminIndexInfo: {
                datas: [],
                action: ''
            }
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        async initData() {
            await this.loadViewAdminData()
            await this.loadShopMonitor()
            await this.loadHousekeepingMonitor()
        },
        async loadViewAdminData() {
            try {
                const params = {
                    platform: 'admin'
                }
                const res = await queryAdminCount(params)

                if (res.code !== 0) {
                    console.log(res)
                    return
                }

                res.data.forEach((item, index) => {
                    if (index % 4 === 0) {
                        item.color = "#1acda1"
                    } else if (index % 4 === 1) {
                        item.color = "#ffae11"
                    } else if (index % 4 === 2) {
                        item.color = "#ff7911"
                    } else if (index % 4 === 3) {
                        item.color = "#3a68f2"
                    }
                })

                this.adminIndexInfo.datas = res.data
            } catch (error) {
                console.error('请求失败:', error)
            }
        },
        async loadShopMonitor() {
            try {
                const params = {
                    platform: 'admin',
                    carType: '3306'
                }
                const res = await queryStoreOrderDayCount(params)

                if (res.code !== 0) {
                    console.log(res)
                    return
                }

                this.initLineEchat(res.data, 'shopStoreOrderEchat')
            } catch (error) {
                console.error('请求失败:', error)
            }
        },
        async loadHousekeepingMonitor() {
            try {
                const params = {
                    platform: 'admin',
                    carType: '3307'
                }
                const res = await queryStoreOrderDayCount(params)

                if (res.code !== 0) {
                    console.log(res)
                    return
                }

                this.initLineEchat(res.data, 'housekeepingStoreOrderEchat')
            } catch (error) {
                console.error('请求失败:', error)
            }
        },
        initLineEchat(data, element) {
            const dom = document.getElementById(element)
            if (!dom) return

            const keys = []
            const values = []
            data.forEach(item => {
                keys.push(item.createTime)
                values.push(item.count)
            })

            const title = element === 'housekeepingStoreOrderEchat'
                ? this.$t('index.admin.housekeeping')
                : this.$t('index.admin.shop')

            const myChart = echarts.init(dom)
            const option = {
                title: {
                    show: true,
                    text: title
                },
                xAxis: {
                    type: 'category',
                    data: keys.reverse()
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: values.reverse(),
                    type: 'line',
                    smooth: true
                }]
            }

            if (option && typeof option === "object") {
                myChart.setOption(option, true)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.admin-index-container {


    .vc-index-nav {
        font-size: 16px;
        color: #666;
        margin-bottom: 20px;

        .margin-right-sm {
            margin-right: 10px;
        }

        .margin-left-sm {
            margin-left: 10px;
        }
    }

    .margin-top {
        margin-top: 20px;
    }

    .margin-bottom {
        margin-bottom: 20px;
    }

    .text-center {
        text-align: center;
    }

    .padding {
        padding: 20px;
    }

    .bg-white {
        background-color: #fff;
    }
}
</style>